import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Prashanth  </span>
            from <span className="purple"> Chintamani, India.</span>
            <br />I am pursuing MSc in Robotics Cognition Intelligence at Technical University of Munich.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Sports
            </li>
            <li className="about-activity">
              <ImPointRight /> Mountain Biking
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Be Lazy, Think Crazy !"{" "}
          </p>
          <footer className="blockquote-footer">Prashanth</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
